import BillLading from '@/components/BillLading/BillLading';
export default {
    name: "sendUpdateBill",
	conditionData:'',
	created: function () {
      this.init();
	},
	components:{
		BillLading
	},
    data() {
        return {
			edit: true,
			showBillLading : true,
			showPdf :false,
			pdfSrc: '',
			numPages: 0,
			progress: 0,
			progressShow: true,
            billLadingData: {
                shipper: "shipper input text",
                consignee: "consignee input text",
                notifyParty: "notifyPart input text", ///
                placeOfreceipt: "placeOfreceipt input text",
                vessel: "vessel input text",
                portOfLoading: "portOfLoading input text",
                portOfTransshipment: "portOfTransshipment input text",
                PortOfDischarge: "portOfDischarge input text", ///
                PlaceOfDelivery: "placeOfDelivery input text", //
                freightCharges: "freightAndCharges input text", //
                NoOfOriginal: "noOfOriginal input text", //
                declared: "declared input text",
                voyageNo: "voyageNo input text",
                preCarriageBy: "carriageBy input text", //
                planceAndDate: "planceAndDate input text",
                forwardingAgent: "forAgent input text", //
                signedBy: "",
                typeOfMovement: "typeOfMovement input text",
                blNo: "billNo input text", //
				goodList:[],
				isAddtionalImageDisplay: ''
            },
			updateWriteBillForm: {
				signer:'',
				issuingParty_label:'',
				billFormatter:'',
				billType:'',
				billAdditionalDescription:'',
				billAdditionalDescriptionOfSend:'',
				billingFee:'',
				issuingTime:'',
				portOfDischarge:'',
				payment:'',
				recFirstAuditResult:'',
				recFirstAuditOpinion:'',
				recFinalAuditResult:'',
				recFinalAuditOpinion:'',
				signAuditResult:'',
				signAuditOpinion:'',
				sendAuditResult:'',
				sendAuditOpinion:'',
				stdContainerNumber:'',
				payType:'',
				isAddtionalImageDisplay:''
			},
			// 公司下拉列表
			companyList: [],
			// 出单费下拉列表
			costList:[],
			logoType: 1,
			imageType: 1,
			isAddtionalImageDisplay: 0,
			isWiffa: false
        }
	},
	computed: {
		rules() {
			return {signer: [
					{ required: true, //是否必填
						message: this.$t('c_addWriteBill.message.signer'), //提示信息
						trigger: 'blur'  //何事件触发
					}
				],
				issuingParty_label: [
					{ required: true, //是否必填
						message: this.$t('c_addWriteBill.message.issuingParty_label'), //提示信息
						trigger: 'blur'  //何事件触发
					}
				],
				billingFee: [
					{ required: true, //是否必填
						message: this.$t('c_addWriteBill.message.billingFee'), //提示信息
						trigger: 'blur'  //何事件触发
					}
				],
				issuingTime: [
					{ required: true, //是否必填
						message: this.$t('c_addWriteBill.message.issuingTime'), //提示信息
						trigger: 'blur'  //何事件触发
					}
				],
				payment: [
					{ required: true, //是否必填
						message: this.$t('c_addWriteBill.message.payment'), //提示信息
						trigger: 'blur'  //何事件触发
					}
				],
				stdContainerNumber: [
					{ required: true, //是否必填
						message: this.$t('c_addWriteBill.message.stdContainerNumber'), //提示信息
						trigger: 'blur'  //何事件触发
					}
				]
			}
		},
		singCompanyList(){
			if(this.updateWriteBillForm.issuingParty_label && this.updateWriteBillForm.signer){
				if(this.updateWriteBillForm.issuingParty_label === this.updateWriteBillForm.signer){
					const id = this.updateWriteBillForm.issuingParty_label;
					return [{id:id, companyName: this.getCompanyName(id)}]
				}else{
					const isId = this.updateWriteBillForm.issuingParty_label;
					const sid = this.updateWriteBillForm.signer;
					return [{id:isId, companyName: this.getCompanyName(isId)},
					{id:sid, companyName: this.getCompanyName(sid)}]
				}
			}
			return [];
		},
		billingFeeCompanyList(){
			let arr = [{
				id: this.conditionData.row.receiveCompanyId,
				companyName: this.conditionData.row.receiveCompanyName
			}];
			if(this.updateWriteBillForm.issuingParty_label && this.updateWriteBillForm.signer){
				if(this.updateWriteBillForm.issuingParty_label === this.updateWriteBillForm.signer){
					const id = this.updateWriteBillForm.issuingParty_label;
					arr.push(...[{id:id, companyName: this.getCompanyName(id)}]);
				}else{
					const isId = this.updateWriteBillForm.issuingParty_label;
					const sid = this.updateWriteBillForm.signer;
					arr.push(...[{id:isId, companyName: this.getCompanyName(isId)},
					{id:sid, companyName: this.getCompanyName(sid)}]);
				}
			}
			return arr;
		},
		logoPath(){
			let url = '/api/file/bill_logo_wiffa.png';
			return url;
			// if (this.logoType === 1){
			// 	return url;
			// }else{
			// 	if(this.updateWriteBillForm.issuingParty_label){
			// 		this.companyList.forEach(item => {
			// 			if(item.id === this.updateWriteBillForm.issuingParty_label){
			// 				if(item.billLogo){
			// 					url = `/api${item.billLogo}`;
			// 				}else{
			// 					// this.$message.info("该公司未提交LOGO，将使用WIFFA LOGO")
			// 					this.$message.info(this.$t('c_addWriteBill.message.noLogo'))
			// 				}
			// 			}
			// 		});
			// 		return url;
			// 	}else{
			// 		return url;
			// 	}
			// }
		},
		addtionalImagePath(){
			let url = '/api/file/bill_addtional_image_wiffa.png';
			return url;
			// if (this.logoType === 1){
			// 	return url;
			// }else{
			// 	if(this.addWriteBillForm.issuingParty_label){
			// 		this.companyList.forEach(item => {
			// 			if(item.id === this.addWriteBillForm.issuingParty_label){
			// 				if(item.billLogo){
			// 					url = `/api${item.billLogo}`;
			// 				}else{
			// 					// this.$message.info("该公司未提交LOGO，将使用WIFFA LOGO")
			// 					this.$message.info(this.$t('c_addWriteBill.message.noLogo'))
			// 				}
			// 			}
			// 		});
			// 		return url;
			// 	}else{
			// 		return url;
			// 	}
			// }
		},
		imagePath(){
			let url = '/api/file/bill_image_wiffa.png';
			if (this.imageType === 1){
				return url;
			}else{
				if(this.updateWriteBillForm.issuingParty_label){
					this.companyList.forEach(item => {
						if(item.id === this.updateWriteBillForm.issuingParty_label){
							if(item.billImage){
								url = `/api${item.billImage}`;
							}else{
								// this.$message.info("该公司未提交抬头，将使用WIFFA抬头")
								this.$message({
									message: this.$t('c_addWriteBill.message.noImage'),
									type: 'info',
									center: true
								});

							}
						}
					});
					return url;
				}else{
					return url;
				}
			}
		}
	},
    methods: {
        init(){
			// 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
			this.conditionData = this.$routerUtil.getParam();
			if(this.conditionData.row){
				this.billLadingData.shipper = this.conditionData.row.shipper;
				this.billLadingData.consignee = this.conditionData.row.consignee;
				this.billLadingData.notifyParty = this.conditionData.row.notifyParty;
				this.billLadingData.placeOfreceipt = this.conditionData.row.placeOfreceipt;
				this.billLadingData.vessel = this.conditionData.row.vessel;
				this.billLadingData.portOfLoading = this.conditionData.row.portOfLoading;
				this.billLadingData.portOfTransshipment = this.conditionData.row.portOfTransshipment;
				this.billLadingData.PortOfDischarge = this.conditionData.row.PortOfDischarge;
				this.billLadingData.PlaceOfDelivery = this.conditionData.row.PlaceOfDelivery;
				this.billLadingData.freightCharges = this.conditionData.row.freightCharges;
				this.billLadingData.NoOfOriginal = this.conditionData.row.NoOfOriginal;
				this.billLadingData.declared = this.conditionData.row.declared;
				this.billLadingData.voyageNo = this.conditionData.row.voyageNo;
				this.billLadingData.preCarriageBy = this.conditionData.row.preCarriageBy;
				this.billLadingData.planceAndDate = this.conditionData.row.planceAndDate;
				this.billLadingData.forwardingAgent = this.conditionData.row.forwardingAgent;
				this.billLadingData.signedBy = this.conditionData.row.signedBy;
				this.billLadingData.typeOfMovement = this.conditionData.row.typeOfMovement;
				this.billLadingData.blNo = this.conditionData.row.blNo;
				this.billLadingData.finalDestination = this.conditionData.row.finalDestination;
				this.billLadingData.totalNumber = this.conditionData.row.totalNumber;
				this.billLadingData.goodList = this.conditionData.row.billGoods;
				this.billLadingData.isAddtionalImageDisplay = this.conditionData.row.isAddtionalImageDisplay;
				this.updateWriteBillForm.signer = this.conditionData.row.signatureCompanyId;
				this.updateWriteBillForm.issuingParty_label = this.conditionData.row.sendCompanyId;
				this.updateWriteBillForm.billingFee = this.conditionData.row.sendBillFeeCompanyId;
				this.updateWriteBillForm.issuingTime = this.conditionData.row.sendBillDate;
				this.updateWriteBillForm.portOfDischarge = this.conditionData.row.costId;
				this.updateWriteBillForm.billFormatter = this.conditionData.row.billFormatter;
				this.updateWriteBillForm.billType = this.conditionData.row.billType;
				this.updateWriteBillForm.billAdditionalDescription = this.conditionData.row.billAdditionalDescription;
				this.updateWriteBillForm.billAdditionalDescriptionOfSend = this.conditionData.row.billAdditionalDescriptionOfSend;
				this.updateWriteBillForm.recFirstAuditResult = this.conditionData.row.rcfAuditResult;
				this.updateWriteBillForm.recFirstAuditOpinion = this.conditionData.row.rcfAuditOpinion;
				this.updateWriteBillForm.recFinalAuditResult = this.conditionData.row.rcsAuditResult;
				this.updateWriteBillForm.recFinalAuditOpinion = this.conditionData.row.rcsAuditOpinion;
				this.updateWriteBillForm.signAuditResult = this.conditionData.row.signAuditResult;
				this.updateWriteBillForm.signAuditOpinion = this.conditionData.row.signAuditOpinion;
				this.updateWriteBillForm.sendAuditResult = this.conditionData.row.scfAuditResult;
				this.updateWriteBillForm.sendAuditOpinion = this.conditionData.row.scfAuditOpinion;
				this.updateWriteBillForm.stdContainerNumber = this.conditionData.row.stdContainerNumber;
				this.updateWriteBillForm.isAddtionalImageDisplay = this.conditionData.row.isAddtionalImageDisplay;
				this.updateWriteBillForm.payment = this.conditionData.row.payType === null ? '' : parseInt(this.conditionData.row.payType);
				this.updateWriteBillForm.payType = this.conditionData.row.payType === null ? '' : parseInt(this.conditionData.row.payType);
				if(this.conditionData.row.billLogoName !== 'bill_logo_wiffa.png'){
					this.logoType = 2;
				}
				// 如果不是wiffa
				if(this.conditionData.row.billImageName !== 'bill_image_wiffa.png'){
					this.imageType = 2;
				}
				// 如果wiffa的title，则默认显示tt club图片，且禁用是否显示选项
				if(this.conditionData.row.billImageName === 'bill_image_wiffa.png'){
					this.updateWriteBillForm.isAddtionalImageDisplay = 1;
					this.isWiffa = true;
				}

				if(this.conditionData.row.billImageName === 'bill_logo_wiffa.png' && this.isAddtionalImageDisplay === 1){
					this.imageType = 1;
					this.isWiffa = false;
				}

			}
			// 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
			// this.conditionData = this.$routerUtil.getParam();
			// 查询当前提单中的收单公司建立合作关系的出单公司下拉列表
			const selectSendCompanyParam = {};
			selectSendCompanyParam.receiveCompanyId = this.conditionData.row.receiveCompanyId;
			this.$axios({
				method: "get",
				url: "api/customerCompay/selecCompayCustomer", 
				params: selectSendCompanyParam
				}).then(res => {
					this.companyList = res.data.resultData;
				}).catch(error => {
					console.log(error);
					this.$message({
						message: this.$t('common.message.operateFail'),
						type: 'error',
						center: true
					});
				});
			// 查询出单费集合下拉
			const param = {};
			// param.isDefault = 0;
			this.$axios.get('/api/cost/selectCostIsDefault',{params:param}).then(response => {
				this.costList = response.data.resultData;
			}).catch(e => {
				console.log(e);
				this.$message({
					message: this.$t('common.message.operateFail'),
					type: 'error',
					center: true
				});
			});
		},
		doBack(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('SendBillApplyManage');
		},
		disableImageList(event) {
			if (event === 1) {
				this.updateWriteBillForm.isAddtionalImageDisplay = 1;
				this.isWiffa = true;
			}
			if (event === 2) {
				this.updateWriteBillForm.isAddtionalImageDisplay = this.conditionData.row.isAddtionalImageDisplay;
				this.isWiffa = false;
			}
		},
		doConfirm(){
			this.$refs.updateWriteBillForm.validate(valid => {
				if (valid) {
					if(this.updateWriteBillForm.stdContainerNumber <= 0){
						this.$message({
							message: this.$t('s_printApplyManage.message.stdContainerNumberZero'),
							type: 'warning',
							center: true
						});
						return;
					}
					var param = new Object();
					param.shipper = this.billLadingData.shipper;
					param.consignee = this.billLadingData.consignee;
					param.notifyParty = this.billLadingData.notifyParty;
					param.placeOfreceipt = this.billLadingData.placeOfreceipt;
					param.vessel = this.billLadingData.vessel;
					param.portOfLoading = this.billLadingData.portOfLoading;
					param.portOfTransshipment = this.billLadingData.portOfTransshipment;
					param.PortOfDischarge = this.billLadingData.PortOfDischarge;
					param.PlaceOfDelivery = this.billLadingData.PlaceOfDelivery;
					param.freightCharges = this.billLadingData.freightCharges;
					param.NoOfOriginal = this.billLadingData.NoOfOriginal;
					param.declared = this.billLadingData.declared;
					param.voyageNo = this.billLadingData.voyageNo;
					param.preCarriageBy = this.billLadingData.preCarriageBy;
					param.planceAndDate = this.billLadingData.planceAndDate;
					param.forwardingAgent = this.billLadingData.forwardingAgent;
					param.signedBy = this.billLadingData.signedBy;
					param.typeOfMovement = this.billLadingData.typeOfMovement;
					param.blNo = this.billLadingData.blNo;
					param.finalDestination = this.billLadingData.finalDestination;
					param.totalNumber = this.billLadingData.totalNumber;
					param.billGoodsList = this.billLadingData.goodList;
					param.receiveCompanyId = this.conditionData.row.receiveCompanyId;
					param.billStatus = this.conditionData.row.billStatus;
					param.proId = this.conditionData.row.proId;
					param.id = this.conditionData.row.id
					param.version = this.conditionData.row.version;
					// 提单格式、提单类型、出单方附加说明
					if (this.updateWriteBillForm.signer){
						param.signatureCompanyId = this.updateWriteBillForm.signer;
					}
					if (this.updateWriteBillForm.billingFee){
						param.sendBillFeeCompanyId = this.updateWriteBillForm.billingFee;
					}
					if (this.updateWriteBillForm.issuingTime){
						param.issuingTime = this.updateWriteBillForm.issuingTime;
					}
					if (this.updateWriteBillForm.portOfDischarge){
						param.costId = this.updateWriteBillForm.portOfDischarge;
					}
					if (this.updateWriteBillForm.payment){
						param.payType = this.updateWriteBillForm.payment;
					}
					if (this.updateWriteBillForm.billFormatter){
						param.billFormatter = this.updateWriteBillForm.billFormatter;
					}
					if (this.updateWriteBillForm.billType){
						param.billType = this.updateWriteBillForm.billType;
					}
					if (this.updateWriteBillForm.billAdditionalDescriptionOfSend){
						param.billAdditionalDescriptionOfSend = this.updateWriteBillForm.billAdditionalDescriptionOfSend;
					}
					if (this.updateWriteBillForm.stdContainerNumber){
						param.stdContainerNumber = this.updateWriteBillForm.stdContainerNumber;
					}

					if (this.updateWriteBillForm.isAddtionalImageDisplay != null){
						param.isAddtionalImageDisplay = this.updateWriteBillForm.isAddtionalImageDisplay;
					}

					// 获取图片路径
					// param.billLogoName = this.conditionData.row.billLogoName;
					// param.billImageName = this.conditionData.row.billImageName;

					param.billLogoName = this.logoPath.substring(this.logoPath.lastIndexOf('/') + 1);
					param.billImageName = this.imagePath.substring(this.imagePath.lastIndexOf('/') + 1);
					param.addtionalImageName = this.addtionalImagePath.substring(this.addtionalImagePath.lastIndexOf('/') + 1);
					// TODO 若出单方选择非wiffa抬头，且选择不显示TT CLUB 图片，则将表中对应字段置空
					if (this.updateWriteBillForm.isAddtionalImageDisplay == 0){
						param.addtionalImageName = null;
					}

					this.$axios({
						method: "put",
						url: "api/receipts/recordUpdate", // 接口地址
						data:param
					}).then(res => {
						if(res.data.status==='1'){
							this.$message({
								// message: this.$t('c_addWriteBill.successMassage'),
								// 2021-01-29 修改消息提示 等待收单方初审
								message: this.$t('c_addWriteBill.toBeCollectFirstAudit'),
								type: 'success',
								center: true
							});
							this.$routerUtil.setParam(this.conditionData.searchForm);
							this.$router.push('SendBillApplyManage');
						}else{
							this.$message({
								message: this.$t(res.data.message),
								type: 'error',
								center: true
							});
						}
					}).catch(error => {
						console.log(error);
						this.$message({
							message: 'This is an error message',
							type: 'error',
							center: true
						});
					});
				}
			});
		},
		getNowFormatDate() {
			const date = new Date();
			const seperator1 = "-";
			const seperator2 = ":";
			let month = date.getMonth() + 1;
			let strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			return date.getFullYear() + seperator1 + month + seperator1 + strDate
			+ " " + date.getHours() + seperator2 + date.getMinutes()
			+ seperator2 + date.getSeconds();
		},
		getCompanyName(id){
			let companyName = '';
			this.companyList.forEach(item => {
				if(id === item.id){
					companyName = item.companyName;
				}
			});
			return companyName;
		}
    }
}
